import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var CheckStageFormCheckTypeInline;
(function (CheckStageFormCheckTypeInline) {
    CheckStageFormCheckTypeInline["ALL"] = "ALL";
    CheckStageFormCheckTypeInline["START"] = "START";
    CheckStageFormCheckTypeInline["DELIVERY_RATE"] = "DELIVERY_RATE";
    CheckStageFormCheckTypeInline["CTR"] = "CTR";
    CheckStageFormCheckTypeInline["VIEWABILITY"] = "VIEWABILITY";
    CheckStageFormCheckTypeInline["HIDDEN"] = "HIDDEN";
    CheckStageFormCheckTypeInline["FINISHED"] = "FINISHED";
})(CheckStageFormCheckTypeInline || (CheckStageFormCheckTypeInline = {}));
export var LineItemServiceResultDtoResultInline;
(function (LineItemServiceResultDtoResultInline) {
    LineItemServiceResultDtoResultInline["OK"] = "OK";
    LineItemServiceResultDtoResultInline["ERROR"] = "ERROR";
})(LineItemServiceResultDtoResultInline || (LineItemServiceResultDtoResultInline = {}));
export var StageComments;
(function (StageComments) {
    StageComments["START_CHECK_SUCCESSFUL"] = "START_CHECK_SUCCESSFUL";
    StageComments["INVENTORY_OPTIMIZED"] = "INVENTORY_OPTIMIZED";
    StageComments["FREQUENCY_CAPPING_OPTIMIZED"] = "FREQUENCY_CAPPING_OPTIMIZED";
    StageComments["GEO_LOCATION_OPTIMIZED"] = "GEO_LOCATION_OPTIMIZED";
    StageComments["SEGMENT_OPTIMIZED"] = "SEGMENT_OPTIMIZED";
    StageComments["DELIVERY_RATE_OPTIMIZED"] = "DELIVERY_RATE_OPTIMIZED";
    StageComments["CTR_OPTIMIZED"] = "CTR_OPTIMIZED";
    StageComments["VIEWABILITY_OPTIMIZED"] = "VIEWABILITY_OPTIMIZED";
    StageComments["DELIVERY_CHECKED"] = "DELIVERY_CHECKED";
    StageComments["CTR_CHECKED"] = "CTR_CHECKED";
    StageComments["VIEWABILITY_CHECKED"] = "VIEWABILITY_CHECKED";
})(StageComments || (StageComments = {}));
export var AdServerStatus;
(function (AdServerStatus) {
    AdServerStatus["NONE"] = "NONE";
    AdServerStatus["INACTIVE"] = "INACTIVE";
    AdServerStatus["ACTIVE"] = "ACTIVE";
})(AdServerStatus || (AdServerStatus = {}));
export var CampaignPositionStatus;
(function (CampaignPositionStatus) {
    CampaignPositionStatus["ALL"] = "ALL";
    CampaignPositionStatus["READY_TO_PUSH"] = "READY_TO_PUSH";
    CampaignPositionStatus["PUSH_UPDATE"] = "PUSH_UPDATE";
    CampaignPositionStatus["CREATIVE_PENDING"] = "CREATIVE_PENDING";
    CampaignPositionStatus["CREATIVE_REQUESTED"] = "CREATIVE_REQUESTED";
    CampaignPositionStatus["CREATIVE_RECEIVED"] = "CREATIVE_RECEIVED";
    CampaignPositionStatus["PENDING"] = "PENDING";
    CampaignPositionStatus["READY"] = "READY";
    CampaignPositionStatus["RUNNING"] = "RUNNING";
    CampaignPositionStatus["ISSUES"] = "ISSUES";
    CampaignPositionStatus["FINISHED"] = "FINISHED";
    CampaignPositionStatus["HIDDEN"] = "HIDDEN";
    CampaignPositionStatus["DELETED"] = "DELETED";
    CampaignPositionStatus["DECLINED"] = "DECLINED";
})(CampaignPositionStatus || (CampaignPositionStatus = {}));
